<template>
	<div class="site-content maintenance">
		<div class="maintenance__content" v-if="maintenanceStatus">
			<div class="maintenance__content__title">
				<img src="../img/maintenanceLogo.png">
			</div>
			<div class="maintenance__content__text">
				Une opération de maintenance est en cours, veuillez nous excuser pour la gêne occasionnée.
			</div>
		</div>
	</div>
</template>

<script>
	import Vuex from 'vuex';

	export default {
		name: "Maintenance",
		beforeRouteEnter(to, from, next){

			//Start constantly check server
			next(vm => {
				vm.$store.commit('addRefresh', 'getMaintenanceStatus')
			})
		},
		beforeRouteLeave(to, from, next){
			this.$store.commit('removeRefresh', 'getMaintenanceStatus');
			next();
		},
		computed:{
			...Vuex.mapGetters([
				'maintenanceStatus'
			]),
			fromPath(){
				return this.$route.query.from;
			}
		},
		watch: {
			maintenanceStatus(){
				this.redirectCheck();
			}
		},
		mounted(){
			this.redirectCheck();
		},
		methods:{
			redirectCheck(){
				if(!this.maintenanceStatus && typeof this.fromPath !== 'undefined'){
					this.$router.push(this.fromPath);
				}
			}
		}
	}

</script>

<style lang="scss">
	//noinspection CssUnknownTarget
	.maintenance{
		background-image: url("../img/banner.jpg");
		min-height: 80vh;
		background-size: cover;
		background-position: center;

		display: flex;
		align-items: center;
		justify-content: center;

		&__content{
			max-width: 100%;
			width: 500px;
			min-height: 225px;
			background-color: rgba(255, 255, 255, 0.6);

			&__title{
				background: #006e34;
				text-align: center;
				padding: 10px 0px 5px 0px;
			}

			&__text{
				color: white;
				font-size: 20px;
				padding: 45px 80px;
				text-align: center;
				font-weight: bold;
			}
		}
	}



</style>